module.exports = __webpack_public_path__ + "img/chuangsai_21.601d614f.jpg";